"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.websiteActivityGqlConfig = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _parse = require("customer-data-sidebar/graphQL/parse");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  query FetchProfileWebsiteActivityCard(\n    $objectType: String!\n    $subjectId: Long!\n  ) {\n    crmObjects {\n      getById(id: $subjectId, type: $objectType) {\n        ... on Contact {\n          id\n          defaultProperties {\n            first_conversion_date {\n              id\n              value\n            }\n            hs_analytics_first_visit_timestamp {\n              id\n              value\n            }\n            hs_analytics_last_visit_timestamp {\n              id\n              value\n            }\n            hs_analytics_num_page_views {\n              id\n              value\n            }\n            hs_analytics_num_visits {\n              id\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var parse = function parse(objectType, data) {
  var subjectData = data.crmObjects.getById;
  var subject = subjectData && (0, _parse.toSubject)(objectType, subjectData);
  return {
    subject: subject
  };
};

var FETCH_PROFILE_WEBSITE_ACTIVITY_CARD = (0, _graphqlTag.default)(_templateObject());
var websiteActivityGqlConfig = {
  parse: parse,
  query: FETCH_PROFILE_WEBSITE_ACTIVITY_CARD
};
exports.websiteActivityGqlConfig = websiteActivityGqlConfig;